var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 58,
    viewBox: "0 0 78 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3943 10C29.5197 10 28 11.5197 28 13.3943C28 15.2689 29.5197 16.7886 31.3943 16.7886H32.6057C34.4803 16.7886 36 15.2689 36 13.3943C36 11.5197 34.4803 10 32.6057 10H31.3943Z",
    fill: "#E56A43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18.0648V21.3548H36V18.0648H28Z",
    fill: "#E56A43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22.2449V25.5349H36V22.2449H28Z",
    fill: "#E56A43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26.4431V29.7332H36V26.4431H28Z",
    fill: "#E56A43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30.5894V46H36V30.5894H28Z",
    fill: "#E56A43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.344 11.4V17.736H16.272V45H9.648V17.736H0.624V11.4H25.344Z",
    fill: "#2E375B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11.4V45H68.424V23.208L58.968 38.808H58.2L48.744 23.256V45H42.12V11.4H48.936L58.584 27.288L68.184 11.4H75Z",
    fill: "#2E375B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimLogo);
export default __webpack_public_path__ + "static/media/TimLogo.45111130e971191bfaea992b9d3d4aa4.svg";
export { ForwardRef as ReactComponent };